import {
  CollapsedSelectionFixer,
  TextSelectionNormalizer,
  NonCollapsedSelectionFixer,
  JSONSelectionNormalizer,
} from './Visitors/Fixers';

export class SelectionFixer {
  static normalizeTextSelection(
    range: Editor.Selection.EditorRange | Editor.Selection.JsonRange,
    options: Partial<Editor.Selection.FixerOptions>,
    DataManager?: Editor.Data.API,
  ) {
    range.accept(new TextSelectionNormalizer(options, DataManager));
  }

  static fixSelection(
    range: DoDOCSelection.DoDOCRange,
    options: Partial<Editor.Selection.FixerOptions>,
  ) {
    let fixer: Editor.Selection.Range.IEditorRangeVisitor;
    if (range.collapsed) {
      fixer = new CollapsedSelectionFixer(options);
    } else {
      fixer = new NonCollapsedSelectionFixer(options);
    }
    range.accept(fixer);
    return fixer.updated;
  }

  static normalizeJsonPath(
    baseData: Editor.Data.Node.Data,
    path: Editor.Selection.Path,
    options: Partial<Editor.Selection.FixerOptions> = {},
  ) {
    return new JSONSelectionNormalizer(options).normalize(baseData, path);
  }
}
